import { render } from "./SuccessPage.vue?vue&type=template&id=59908741&ts=true"
import script from "./SuccessPage.vue?vue&type=script&lang=ts"
export * from "./SuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__